/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Meta_DescInputs */

const en_pc_cmp_meta_desc = /** @type {(inputs: Pc_Cmp_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An honest comparison of PdfCraft and Adobe Acrobat: price, platforms, privacy, features and what the free ArtCraft PdfCraft editor can't do yet.`)
};

const zh_pc_cmp_meta_desc = /** @type {(inputs: Pc_Cmp_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 与 Adobe Acrobat 的客观对比：价格、平台、隐私、功能，以及免费的 ArtCraft PdfCraft 目前还做不到的事。`)
};

/**
* | output |
* | --- |
* | "An honest comparison of PdfCraft and Adobe Acrobat: price, platforms, privacy, features and what the free ArtCraft PdfCraft editor can't do yet." |
*
* @param {Pc_Cmp_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_meta_desc = /** @type {((inputs?: Pc_Cmp_Meta_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Meta_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_meta_desc(inputs)
	return zh_pc_cmp_meta_desc(inputs)
});
export { pc_cmp_meta_desc as "pc.cmp.meta_desc" }